import React from 'react';
import { CheckIcon } from 'lucide-react';
import { offerChecklist, BOX_IMAGE, CHECKOUT_URL } from '../data/content';
import { CTAButton, TrustLine } from './CTAButton';
export function Offer() {
  return <section id="comprar" className="scroll-mt-1 bg-white px-3 py-4 sm:px-6" data-id="element-115" data-mp="1mnscei9wcob6">
      <div className="mx-auto max-w-lg" data-id="element-116" data-mp="1hopi9svgg2hz">
        <p className="text-center font-body text-[0.66rem] font-extrabold uppercase tracking-[0.22em] text-gold sm:text-xs" data-id="element-117" data-mp="1hpqrdrswuex2">
          Special Launch Offer
        </p>
        <div className="mt-1 rounded-lg border-2 border-gold bg-ivory p-3 shadow-lg" data-id="element-118" data-mp="p0a1b0srja40">
          <h2 className="text-center font-heading text-[1.15rem] font-bold uppercase leading-tight text-navy sm:text-[1.6rem]" data-id="element-119" data-mp="13wrfs0w914us">
            🧪 Clinical Lab Visual Atlas™
          </h2>
          <p className="text-center font-body text-[0.66rem] font-bold uppercase tracking-wide text-clinical sm:text-xs" data-id="element-120" data-mp="2fc6a0wx2pim7">
            The Complete Visual Reference System for Clinical Lab Science
          </p>

          <a href={CHECKOUT_URL} rel="noopener" className="mt-1.5 block" data-id="element-121" data-mp="pkh6pbiggwg7">
            <img src={BOX_IMAGE} alt="CLINICAL LAB VISUAL ATLAS™ complete 6-in-1 system" className="mx-auto w-full max-w-[170px]" data-id="element-122" data-mp="pmbkm5vb7oas" />
          </a>

          <p className="mt-0.5 text-center font-body text-[0.74rem] font-extrabold uppercase tracking-wide text-navy" data-id="element-123" data-mp="zgak0x400tz1">
            Complete 6-in-1 System
          </p>

          <ul className="mt-1.5 space-y-0.5" data-id="element-124" data-mp="6v0w1vd23nm2">
            {offerChecklist.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-125" data-mp="btlubp8qzx7v">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-clinical" strokeWidth={3.5} aria-hidden="true" data-id="element-126" data-mp="ftw0b1wjinmq" />
                <span className="text-[0.8rem] leading-[1.35] text-ink sm:text-[0.95rem]" data-id="element-127" data-mp="3k8vrcixs6c8s">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mt-2 text-center font-body text-[0.84rem] font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-128" data-mp="vfqx2230ncs7">
            🔥 Get Clinical Lab Visual Atlas™ today
          </p>
          <p className="text-center font-heading text-[2.4rem] font-bold leading-none text-burgundy sm:text-5xl" data-id="element-129" data-mp="qetdpm69scp4">
            $26.90
          </p>

          <div className="mt-2" data-id="element-130" data-mp="107ie9m0a865o">
            <CTAButton label="🧪 Get instant access" sub="Immediate Digital Access" target="checkout" data-id="element-131" data-mp="108k26r2ecn4t" />
          </div>
          <TrustLine className="mt-1.5" data-id="element-132" data-mp="7j3axwqijca6" />
        </div>
      </div>
    </section>;
}